// extracted by mini-css-extract-plugin
export default {"wrapper":"avatar_wrapper__W9CNr","avatar_wrap":"avatar_avatar_wrap__WSF1i","badge":"avatar_badge__JQAgZ"};